import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import type { FieldValidation } from '@rjsf/utils';
import React, { useState } from 'react';
import { RepoAuthorizationProps } from './schema';

export { RepoAuthorizationSchema } from './schema';

export const RepoAuthorization = (props: RepoAuthorizationProps ) => {
  const { uiSchema, formData, onChange } = props;
  const scmAuthApi = useApi(scmAuthApiRef);
  const { secrets, setSecrets } = useTemplateSecrets();
  const [checked, setChecked] = useState(formData);
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = async (isChecked: boolean) => {
    setChecked(isChecked);

    if (onChange) {
      onChange(isChecked);
    }

    if (!isChecked) return;

    const requestUserCredentials = uiSchema?.['ui:options']?.requestUserCredentials as { secretsKey: string };
    if (!requestUserCredentials) return;

    if (secrets[requestUserCredentials.secretsKey]) return;

    setLoading(true);

    try {
      const { token } = await scmAuthApi.getCredentials({
        url: `https://dev.azure.com`,
        additionalScope: {
          repoWrite: true,
        },
      });

      setSecrets({ [requestUserCredentials.secretsKey]: token });
    } catch (error) {
      /* eslint no-console: ["error", { allow: ["error"] }] */
      console.error('Failed to fetch credentials:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={e => handleCheckboxChange(e.target.checked)}
            disabled={loading || checked}
          />
        }
        label={uiSchema?.['ui:options']?.label || 'I consent to the use of my credentials'}
      />
      {loading && <p>Loading credentials...</p>}
    </FormControl>
  );
};


export const validationRepoAuthorization = (
  value: boolean,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('Please check the box to proceed!');
  }
};
